module.exports = __webpack_public_path__ + "img/n11-logo.e96cf3fe.jpg";